import { initCLodop, getLodop } from './LodopFuncs';

export default {
    install(Vue) {
        // eslint-disable-next-line consistent-return
        Vue.prototype.$printPreview = function (printCode, dataItem, successCallback) {
            initCLodop();
            this.$confirm('是否打印', '确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$axios
                    .post('/interfaceApi/basicplatform/print/generate_print_template', {
                        printCode: printCode,
                        printFields: dataItem,
                    })
                    .then(res => {
                        if (res) {
                            const LODOP = getLodop(this);
                            if (LODOP) {
                                // eslint-disable-next-line no-eval
                                eval(res);
                                LODOP.PREVIEW();
                                if (successCallback) {
                                    successCallback();
                                }
                            }
                        }
                    })
                    .catch(error => {
                        this.$message.error(error.ErrorCode.Message);
                    });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消打印',
                });
            });
        };
        /**
         * 模板打印
         * @param config {printCode, dataItem, success,type}
         */
        Vue.prototype.$printTemplate = async function (config) {
            try {
                initCLodop();
                const res = await this.$axios.post('/interfaceApi/basicplatform/print/generate_print_template', {
                    printCode: config.printCode,
                    printFields: config.dataItem,
                });
                if (res) {
                    const LODOP = getLodop(this);
                    if (LODOP) {
                        // eslint-disable-next-line no-eval
                        eval(res);
                        if (config.type === 'print') {
                            LODOP.PRINT();
                        } else {
                            LODOP.PREVIEW();
                        }
                        if (config.success) {
                            config.success();
                        }
                    }
                }
            } catch (error) {
                if (error.ErrorCode) {
                    this.$message.error(error.ErrorCode.Message);
                } else {
                    this.$message.error(error.message);
                }
            }
        };
        Vue.prototype.$getLodop = _that => {
            return getLodop(_that);
        };
        Vue.prototype.$initCLodop = initCLodop;
    },
};
